import { Tween } from "../../../vendor_core/core/src/Tween";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import CascadeExplodeWinningsState from "../../../vendor_core/core/src/states/cascade/CascadeExplodeWinningsState";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import CascadeReelGroup from "../../../vendor_core/core/src/views/CascadeReelGroup";
/**
 * Exit of this state must be when all symbols are exploded !
 */
export default class TRWCascadeExplodeWinningsState extends CascadeExplodeWinningsState {
    protected delayToExit: number = 30; // 50
    protected animationTime: number = 160; // 225
    protected explodedAnimDuration: number = 160; // 225
    protected init(): void {
        this.reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as CascadeReelGroup;

        // Clear win lines and info
        // this.reelGroup.hideLinesAndInfo(true);

        // Set up delay to exit
        this.setExitDelayTween();

        // Move all wining symbols to coin transform place
        this.moveSymbols();

        // Remove the winning symbols
        this.reelGroup.popSymbols(SpinModel.getCurrentCascadeExplodeMap());
    }

    moveSymbols(): void {
        const moveTime = this.animationTime / 1000;
        const winsData = SpinModel.getCurrentWinsData() as any[];
        const cascadeData = SpinModel.generations[SpinModel.cascadeIndex];
        SoundController.playSound("symbolRemove");
        SoundController.playSound("goldCoinHighlight");
        winsData.forEach((d, winIndex) => {
            const target = this.reelGroup.getSymbolAt(
                cascadeData.newCoins[winIndex].coordinate.x,
                cascadeData.newCoins[winIndex].coordinate.y
            );
            (d.coordinates as any[]).forEach(({ x, y }) => {
                const anim = this.reelGroup.winSymbolsView.getAnimAtReelCell(
                    x - 1,
                    y - 1
                );
                if (anim && target) {
                    Tween.to(anim.position, moveTime, {
                        x: target.position.x,
                        y: target.position.y,
                        onComplete: () => {
                            anim.setVisible(false);
                        },
                    });
                }
            });
        });
    }
}
